import Cookies from 'js-cookie'

export default async function (apiUrl, favor) {
    var token = Cookies.get('token') // пробуем получить из куки
    
    // если в куках токена нет, то получаем новый
    if (token === undefined) await getNewToken()
    // если токена не было в куках, и получить его не удалось, то ничего не делаем
    // если токен все же получен, пытаемся отправить
    if (token !== undefined) var sendResult = await send(favor)
    
    // если предыдущая попытка отправки завершилась Unauthorized, то пробуем обновить токен (возможно он битый)
    if (sendResult === 401) {
        await getNewToken()
        await send(favor)
    }
    
    async function getNewToken() {
        try {
            let responseBody = await fetch(apiUrl+'/auth/guest/token', {
                headers: {
                    'Content-Type': 'application/vnd.api+json',
                    'Accept': 'application/vnd.api+json'
                }
            })

            if (responseBody.status === 201) {
                let response = await responseBody.json()
                token = response.data.attributes.value
                // устанавливаем новый кукис
                Cookies.remove('token')
                Cookies.set('token', token)
            }
        } catch (err) {
            console.log(err)
        }
    }
    
    async function send(favor) {
        try {
            let response = await fetch(apiUrl+'/favors', {
                method: 'POST',
                cache: 'no-cache',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    data: {
                        type: 'favor',
                        attributes: {
                            ...favor
                        }
                    }
                })
            })

            return response.status
        } catch (err) {
            console.log(err)
            return 500
        }
    }
}